export default function stopPropagation(event: MouseEvent) {
  return event?.stopPropagation?.()
}
export function stopPropagationAndPrevent(event: MouseEvent) {
  event?.preventDefault?.()
  stopPropagation(event)
}
